exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#client-switch-prompt-modal .modal-content,#client-switch-prompt-modal .modal-dialog{min-height:250px}", ""]);

// exports
